import { MechanicSortFields, SortOrder } from "@/shared/services/graphql/generated/consumer-graph-types";
import { DocumentNode, OperationVariables } from "@apollo/client/core";
import { computed } from "vue";
import { Aggregations, Facet } from "@/shared/facets/facets.model";
import { consumerClient } from "@/shared/services/apollo-clients/consumer-client";
import { getAggregationsForFacet } from "@/shared/facets/composables/facets-aggregation";
import { useI18n } from "vue-i18n";

export const getAggregations = async (
    facet: Facet,
    query: DocumentNode,
    variables: OperationVariables
): Promise<Aggregations> => {
    const aggregationsForDatafield = await consumerClient.query({
        query,
        variables,
        fetchPolicy: "no-cache",
    });

    return getAggregationsForFacet(facet, aggregationsForDatafield?.data?.mechanics?.aggregations);
};

export function useMechanicArticlesListSort() {
    const { t } = useI18n();

    const sortOrderItems = computed(() => {
        return [
            {
                id: "Ranking",
                title: t("shared.Ranking"),
                value: {
                    field: MechanicSortFields.score,
                    order: SortOrder.desc,
                },
            },
            {
                id: "Articlenumber ascending",
                title: t("mechanic.Article number ascending"),
                value: {
                    field: MechanicSortFields.articleNumber,
                    order: SortOrder.asc,
                },
            },
            {
                id: "Articlenumber descending",
                title: t("mechanic.Article number descending"),
                value: {
                    field: MechanicSortFields.articleNumber,
                    order: SortOrder.desc,
                },
            },
            {
                id: "Title ascending",
                title: t("mechanic.Title ascending"),
                value: {
                    field: MechanicSortFields.title,
                    order: SortOrder.asc,
                },
            },
            {
                id: "Title descending",
                title: t("shared.Title descending"),
                value: {
                    field: MechanicSortFields.title,
                    order: SortOrder.desc,
                },
            },
        ];
    });

    return { sortOrderItems };
}
